import { isOpenAt } from "@toema/shared-types";
import type { HoursProfile } from "@toema/shared-types";
import { describeWindows, footerRows } from "../lib/hours.js";
import type { ShopIdentity } from "../lib/shop.js";
import "./Footer.css";

interface FooterProps {
  shop: ShopIdentity;
  profile: HoursProfile;
}

export default function Footer({ shop, profile }: FooterProps) {
  const now = new Date();
  const rows = footerRows(profile, now);
  const open = isOpenAt(profile, now);

  return (
    <footer className="footer">
      <div className="wrap footer__inner">
        <div className="footer__block">
          <h2 className="footer__name">{shop.name}</h2>
          <address className="footer__address">
            {shop.addressLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
            <a className="footer__phone" href={`tel:${shop.phoneHref}`}>
              {shop.phone}
            </a>
          </address>
        </div>

        <div className="footer__block">
          <h3 className="footer__heading">Opening hours</h3>
          {/* A real table: this is two columns of tabular data, and a screen
              reader should be able to say "Friday, 16:00 to 00:30". */}
          <table className="hours">
            <caption className="u-sr-only">
              Opening hours by day. {open ? "Open now." : "Closed now."}
            </caption>
            <tbody>
              {rows.map((entry) => (
                <tr
                  key={entry.date}
                  className={entry.isToday ? "hours__row hours__row--today" : "hours__row"}
                >
                  <th scope="row" className="hours__day">
                    <span className="hours__name">
                      {entry.name}
                      {entry.note !== null && (
                        <>
                          {" · "}
                          <span dir="auto">{entry.note}</span>
                        </>
                      )}
                    </span>
                    {entry.isToday && <span className="u-sr-only"> (today)</span>}
                  </th>
                  <td className="hours__time">{describeWindows(entry.windows)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </footer>
  );
}
